import { secureApi } from 'services/api';
import { UserSettingsPayload } from 'services/api/user-settings/types';
import { UserSettings } from 'types/entities/UserSettings';

const defaultValues: UserSettings = {
  measurementUnit: 'US',
  subscribedToAlerts: true,
  subscribedToMessages: true,
  subscribedToNotifications: true,
};

export const userSettingsApi = secureApi.injectEndpoints({
  endpoints: builder => ({
    getUserSettings: builder.query<UserSettings, void>({
      query: () => ({
        url: '/api/user/settings',
        method: 'GET',
      }),
      providesTags: ['User Settings'],
      transformResponse: (response: UserSettingsPayload) => {
        return { ...defaultValues, ...response.settings };
      },
      transformErrorResponse: () => {
        const measurementUnit = window.navigator.language.includes('-US')
          ? 'US'
          : 'METRIC';
        return { ...defaultValues, measurementUnit };
      },
    }),
    updateUserSettings: builder.mutation<UserSettings, Partial<UserSettings>>({
      query: settingsPatch => ({
        url: 'api/user/settings',
        method: 'POST',
        data: {
          settings: settingsPatch,
        },
      }),
      async onQueryStarted(settingsPatch, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          userSettingsApi.util.updateQueryData(
            'getUserSettings',
            undefined,
            draft => {
              Object.assign(draft, settingsPatch);
            },
          ),
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
  overrideExisting: true,
});
